__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "players";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("axios", "1.17.0", () => (() => (__webpack_require__(8846))), 1);
			register("i18next-http-backend", "3.0.6", () => (() => (__webpack_require__(7263))), 1);
			register("i18next", "25.10.10", () => (() => (__webpack_require__(1174))), 1);
			register("next/compat/router", "15.5.18", () => (() => (__webpack_require__(5575))), 1);
			register("next/dynamic", "15.5.18", () => (__webpack_require__.e(613).then(() => (() => (__webpack_require__(1613))))));
			register("next/head", "15.5.18", () => (() => (__webpack_require__(7506))), 1);
			register("next/image", "15.5.18", () => (__webpack_require__.e(861).then(() => (() => (__webpack_require__(1861))))));
			register("next/link", "15.5.18", () => (() => (__webpack_require__(6328))), 1);
			register("next/link", "15.5.18", () => (() => (__webpack_require__(3723))), 1);
			register("next/router", "15.5.18", () => (() => (__webpack_require__(4433))), 1);
			register("next/script", "15.5.18", () => (__webpack_require__.e(551).then(() => (() => (__webpack_require__(2551))))));
			register("react-dom", "19.1.0", () => (() => (__webpack_require__(4518))), 1);
			register("react-i18next", "15.7.4", () => (() => (__webpack_require__(5246))), 1);
			register("stores/use-basket-store", "1.0.0", () => (() => (__webpack_require__(8790))), 1);
			register("stores/use-user-store", "1.0.0", () => (() => (__webpack_require__(1882))), 1);
			register("zod", "3.25.76", () => (() => (__webpack_require__(1192))), 1);
			register("zustand", "4.5.7", () => (() => (__webpack_require__(9971))), 1);
			register("react-dom/client", "19.1.0", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(2181))))));
			register("react/jsx-runtime", "19.1.0", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4489))))));
			register("react", "19.1.0", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4349))))));
			register("styled-jsx/style", "5.1.6", () => (__webpack_require__.e(413).then(() => (() => (__webpack_require__(8413))))));
			register("styled-jsx", "5.1.6", () => (__webpack_require__.e(532).then(() => (() => (__webpack_require__(9151))))));
			initExternal(1005);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};